import { Box, ButtonProps as MuiButtonProps, Typography } from '@mui/material';

import { Form } from '@hrlogics/react-components/form';

import { Button, Modal } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';

type BaseConfirmationModalProps = {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
  maxWidth?: false | number | 'auto';
  title?: string;
  contentText: string;
  buttonText: string;
  actionButtonColor: MuiButtonProps['color'];
};

export const BaseConfirmationModal: React.FC<BaseConfirmationModalProps> = ({
  isOpen,
  onSubmit,
  onClose,
  maxWidth = 480,
  title = 'Are You sure?',
  contentText,
  buttonText,
  actionButtonColor,
}) => {
  const { isMobile } = useScreenInfo();

  return (
    <Modal
      title={title}
      headerProps={{
        sx: {
          pt: isMobile ? 2 : 3,
          pb: '0',
        },
      }}
      maxWidth={isMobile ? 'auto' : maxWidth}
      dialogProps={{
        onClose,
        open: isOpen,
        fullWidth: true,
        sx: {
          margin: '0 auto',
          p: '0 0 0 10px',
        },
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {contentText}
      </Typography>
      <Form onSubmit={onSubmit} subscription={{ submitting: true }}>
        {({ submitting }) => (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="stretch"
            gap={isMobile ? 2 : 5}
            mt={3}
            px={isMobile ? 0 : 3}
          >
            <Button
              sx={{ flex: '1 1 auto' }}
              size="large"
              variant="outlined"
              color="inherit"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              sx={{ flex: '1 1 auto' }}
              size="large"
              loading={submitting}
              disabled={submitting}
              variant="contained"
              type="submit"
              color={actionButtonColor}
            >
              {buttonText}
            </Button>
          </Box>
        )}
      </Form>
    </Modal>
  );
};
